import { render } from "./ui-task-search.vue?vue&type=template&id=5cbe5cf7&scoped=true"
import script from "./ui-task-search.vue?vue&type=script&lang=js"
export * from "./ui-task-search.vue?vue&type=script&lang=js"

import "./ui-task-search.vue?vue&type=style&index=0&id=5cbe5cf7&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbe5cf7"]])

export default __exports__